import React, { useEffect } from 'react';
import PatientSearch from './PatientSearch';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from '@tanstack/react-router';
import { actions } from './Patients.redux';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';
import { Pets } from '@mui/icons-material';
import { Grid as MUIGrid } from '@mui/material';
import PatientCell from './PatientCell';

const Patients = () => {
    const navigate = useNavigate();
    const patientList = useSelector((state) => state.patients.patients);
    const totalRecords = useSelector((state) => state.patients.totalRecords);
    const pageNumber = useSelector((state) => state.patients.searchTerms.page_number);
    const pageSize = useSelector((state) => state.patients.searchTerms.page_size);
    const loading = useSelector((state) => state.patients.loading);
    const dispatch = useDispatch();
    const handleSearch = () => dispatch(actions.search());
    const resetAll = () => dispatch(actions.resetAll());

    const columns = [
        { field: 'patient_name', headerName: 'Patient Name', flex: 1, minWidth: 180, sortable: false },
        { field: 'client_name', headerName: 'Client Name', flex: 1, minWidth: 180, sortable: false },
        { field: 'breed', headerName: 'Breed', flex: 1, minWidth: 150, sortable: false },
        { field: 'last_visit', headerName: 'Last Visit', flex: 1, minWidth: 150, sortable: false },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => <PatientCell {...params} />,
        },
    ];

    const handlePaginationModelChange = (newModel) => {
        if (loading) {
            return;
        }

        dispatch(actions.setSearchTerm('page_number', newModel.page));
        dispatch(actions.setSearchTerm('page_size', newModel.pageSize));
        dispatch(actions.search());
    };

    useEffect(() => {
        handleSearch();

        return () => {
            resetAll();
        };
    }, []);

    return (
        <MUIGrid container spacing={4}>
            <MUIGrid size={{ xs: 12, lg: 3, xl: 4 }}>
                <PatientSearch />
            </MUIGrid>

            <MUIGrid size={{ xs: 12, lg: 9, xl: 8 }}>
                <DashboardCard
                    color={'green'}
                    icon={<Pets />}
                    topContent={'Patients'}
                    topLabel="Click a patient to view their profile"
                    size="xl"
                >
                    <div style={{ width: '100%' }}>
                        <DataGrid
                            rows={patientList}
                            columns={columns}
                            getRowId={(row) => row.patient_id}
                            rowCount={Number(totalRecords) || 0}
                            pagination
                            paginationMode="server"
                            pageSizeOptions={[5, 10, 20, 50]}
                            paginationModel={{ page: pageNumber, pageSize }}
                            onPaginationModelChange={handlePaginationModelChange}
                            loading={loading}
                            disableRowSelectionOnClick
                            disableColumnMenu
                            disableCellFocus
                            sx={{
                                '& .MuiDataGrid-row': { cursor: 'pointer' },
                                '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                                '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                    outline: 'none',
                                },
                            }}
                            slots={{ pagination: NumberedDataGridPagination }}
                            onRowClick={(params) => {
                                if (params.field !== 'actions') {
                                    navigate({ to: `/patients/view/${params.row.patient_id}` });
                                }
                            }}
                            autoHeight
                        />
                    </div>
                </DashboardCard>
            </MUIGrid>
        </MUIGrid>
    );
};

export default Patients;
